export default __webpack_public_path__ + "static/media/adobexd.fc74e80f.svg";